import { useSearchParams } from 'react-router';

import { FetchedResultPage } from './fetched-result-page.tsx';
import { ResultPage } from './result-page.tsx';

export function ResultRoute() {
  const [params] = useSearchParams();
  return params.has('id') ? <FetchedResultPage /> : <ResultPage />;
}
